import { FormStatus, KYCStatus } from '@anchorage/graphql/generated';
import type { SignalStatus } from '@latitude/signal';

export const getKYCSignalStatus = (
  status: FormStatus | KYCStatus,
): SignalStatus => {
  switch (status) {
    case FormStatus.COMPLETE:
    case KYCStatus.COMPLETE:
    case KYCStatus.READY:
      return 'success';
    case FormStatus.IN_PROGRESS:
    case FormStatus.IN_REVIEW:
    case KYCStatus.IN_PROGRESS:
    case KYCStatus.IN_REVIEW:
    case KYCStatus.PENDING:
      return 'informational';
    case FormStatus.DRAFT:
    case KYCStatus.DRAFT:
      return 'warning';
    default:
      return 'default';
  }
};
